import React, { SVGProps } from 'react';

const InfoIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 17 17"
			fill="none"
			{...props}
		>
			<path
				d="M8.5 0.5C4.08187 0.5 0.5 4.08187 0.5 8.5C0.5 12.9181 4.08187 16.5 8.5 16.5C12.9181 16.5 16.5 12.9181 16.5 8.5C16.5 4.08187 12.9181 0.5 8.5 0.5ZM9.51313 11.8619C9.51313 11.9949 9.48692 12.1267 9.43601 12.2496C9.38509 12.3725 9.31046 12.4842 9.21639 12.5783C9.12231 12.6723 9.01062 12.747 8.88771 12.7979C8.76479 12.8488 8.63305 12.875 8.5 12.875C8.36695 12.875 8.23521 12.8488 8.11229 12.7979C7.98938 12.747 7.87769 12.6723 7.78361 12.5783C7.68953 12.4842 7.61491 12.3725 7.56399 12.2496C7.51308 12.1267 7.48688 11.9949 7.48688 11.8619V7.80906C7.48688 7.67602 7.51308 7.54427 7.56399 7.42136C7.61491 7.29844 7.68953 7.18675 7.78361 7.09267C7.87769 6.9986 7.98938 6.92397 8.11229 6.87306C8.23521 6.82214 8.36695 6.79594 8.5 6.79594C8.63305 6.79594 8.76479 6.82214 8.88771 6.87306C9.01062 6.92397 9.12231 6.9986 9.21639 7.09267C9.31046 7.18675 9.38509 7.29844 9.43601 7.42136C9.48692 7.54427 9.51313 7.67602 9.51313 7.80906V11.8619ZM8.5 6.15125C8.29962 6.15125 8.10375 6.09183 7.93714 5.98051C7.77053 5.86918 7.64068 5.71096 7.56399 5.52583C7.48731 5.34071 7.46725 5.137 7.50634 4.94047C7.54543 4.74395 7.64192 4.56343 7.78361 4.42174C7.9253 4.28005 8.10582 4.18356 8.30235 4.14447C8.49888 4.10538 8.70258 4.12544 8.88771 4.20212C9.07283 4.2788 9.23106 4.40866 9.34238 4.57526C9.45371 4.74187 9.51313 4.93775 9.51313 5.13812C9.51317 5.27118 9.48699 5.40294 9.43609 5.52588C9.38519 5.64882 9.31056 5.76052 9.21648 5.8546C9.12239 5.94869 9.01069 6.02331 8.88775 6.07421C8.76482 6.12511 8.63306 6.15129 8.5 6.15125Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default InfoIcon;
